<template>
	<div class="body">
		<div class="banner"></div>
		
		<div class="login">
			<div class="title flex-baseline">
				<h1>账号登录</h1>
				<p>ACCOUNT LOGIN</p>
			</div>
			<div class="item flex-center">
				<i class="tf">&#xe670;</i>
				<input v-model="username" class="flex-grow" type="text" placeholder="请输入您的姓名" @keydown.enter="loginHandle">
			</div>
			<div class="item flex-center">
				<i class="tf">&#xe73d;</i>
				<input v-model="phone" class="flex-grow" type="text" placeholder="请输入您的手机号码" @keydown.enter="loginHandle">
			</div>
			<button @click="loginHandle">登录</button>
			<!--<button class="tacs-sso-btn" @click="tacsSsoLogin">豫事办登录</button>-->
		</div>
		
		<smscode ref="sms" @getSmscode="getSmscode" @submit="validHandle"></smscode>
	</div>
</template>

<script>
	import smscode from '@/components/module/smscode.vue'
	import fun from '@/assets/script/function.js'
	
	export default {
		components: {
			smscode
		},
		
		data() {
			return {
				username: '',
				phone: '',
				showQrcode: false
			};
		},
		
		mounted() {
			window.addEventListener('message', res => {
				if (res.data.code) {
					this.request({
						url: '/zzd/login',
						data: {
							type: 2,
							code: res.data.code
						},
						loading: true,
						success: data => {
							fun.setCookie('session_id', data.sessionId);
							this.$store.commit('setUserInfo', data);
							this.navigateTo('/');
						},
						error: function (data,b,c) {
							alert("系统出错！");
						}
					});
				}
			});
		},
		
		methods: {
			loginHandle() {
				if (!this.username.trim() || !this.phone.trim()) {
					this.$message({
						text: '请输入姓名和手机号'
					});
					return;
				}
				
				this.$refs.sms.getSmscode();
			},
			
			getSmscode(next) {
				this.request({
					url: '/user/qy/login_code',
					data: {
						user_realname: this.username,
						user_phone: this.phone
					},
					loading: true,
					success: data => {
						this._token = data;
						next();
						this.$refs.sms.open(this.phone);
					}
				});
			},
			
			validHandle(code, next) {
				if (!code) {
					this.$message({
						text: '请输入短信验证码'
					});
					return;
				}
				
				this.request({
					url: '/user/qy/login',
					data: {
						code_token: this._token,
						verify_code: code
					},
					loading: true,
					success: data => {
						fun.setCookie('session_id', data.sessionId);
						this.$store.commit('setUserInfo', data);
						this.navigateTo('/');
					}
				});
			},
			
			tacsSsoLogin() {
				window.location.href = 'https://zjcs.hy.asentop.cn/auth/sso/authorize?redirect_url=' + encodeURIComponent(window.location.origin + '/#/tacs_sso/callback');
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.body {
		height: 100vh;
		overflow: hidden;
		background: #fff;
	}
	
	.banner {
		height: 4.7rem;
		margin-bottom: -.4rem;
		background-image: url('~@/assets/image/login/bg.jpg');
		background-position: center;
		background-size: cover;
	}
	
	.main {
		width: 950px;
		margin: 100px auto 0;
	}

	.login {
		border-radius: .4rem .4rem 0 0;
		padding: .86rem .75rem;
		background: #fff;
		
		.title {
			gap: .16rem;
			margin-bottom: .36rem;
			font-size: .24rem;
			color: #bbb;
			
			h1 {
				font-size: .52rem;
				font-weight: normal
				color: #000;
			}
		}
		
		.item {
			height: .92rem;
			margin-bottom: .34rem;
			font-size: 0;
			background: #F9F9F9;
			
			&:focus-within {
				.tf {
					color: #1492FF;
				}
			}
			
			.tf {
				width: .84rem;
				font-size: .36rem;
				text-align: center;
				color: #bbb;
			}
			
			input {
				height: 100%;
				border: none;
				font-size: .3rem;
			}
		}
		
		button {
			display: block;
			width: 100%;
			height: .96rem;
			border: none;
			border-radius: .48rem;
			font-size: .36rem;
			color: #fff;
			background: #0366F1;
		}
		
		.tacs-sso-btn {
			margin-top: .3rem;
			border: 1px solid #0366F1;
			color: #0366F1;
			background: #fff;
		}
		
		.link {
			width: 400px;
			margin-left: 130px;
			margin-top: 25px;
			font-size: 16px;
			color: #3296FA;
			
			a {
				color: #FEDD00;
			}
		}
	}
</style>